import { gql } from "@apollo/client";

export const GET_ALL_SCHEDULES = gql`
  query GetAllSchedules {
    getAllSchedules {
      performance {
        cronExpression
        lastExecution
        lastStatus
        nextExecution
      }
      invoice {
        cronExpression
        lastExecution
        lastStatus
        nextExecution
      }
      infra {
        cronExpression
        lastExecution
        lastStatus
        nextExecution
      }
      alert {
        cronExpression
        lastExecution
        lastStatus
        nextExecution
      }
      monthlyCost {
        cronExpression
        lastExecution
        lastStatus
        nextExecution
      }
      backup {
        cronExpression
        lastExecution
        lastStatus
        nextExecution
      }
    }
  }
`;

export const UPDATE_SCHEDULER = gql`
  mutation UpdateScheduler($task: String!, $cronExpression: String!) {
    updateScheduler(task: $task, cronExpression: $cronExpression)
  }
`;

export const SYNC_INFRASTRUCTURE = gql`
  mutation SyncAzureInfrastructure {
    syncAzureInfrastructure
  }
`;

export const SYNC_PERFORMANCE = gql`
  mutation TriggerMetricsSync {
    triggerMetricsSync
  }
`;

export const SYNC_ALERTS = gql`
  mutation TriggerAlertSync {
    triggerAlertSync
  }
`;

export const SYNC_INVOICES = gql`
  mutation SavePreviousMonthInvoice {
    savePreviousMonthInvoice
  }
`;

export const SYNC_MONTHLY_COSTS = gql`
  mutation SyncMonthlyCosts($year: Int!, $month: Int!) {
    syncMonthlyCosts(year: $year, month: $month)
  }
`;

export const SYNC_BACKUP = gql`
  mutation SyncBackupData {
    syncBackupData
  }
`;